import { useContext } from "react";
import { UpdateUserProductNotificationContext } from "../customContext/userProductNotificationProvider";

export function useUpdateUserProductNotificationCtx(){
    const ctx = useContext(UpdateUserProductNotificationContext);
    if(!ctx){
        throw new Error('useUpdateUserProductNotificationCtx must be used within UserProductNotificationProdivider context')
    };
    return ctx
}